/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreditNoteLine
 */
export interface CreditNoteLine {
  /**
   * Amount excluding tax, in CAD.
   * @type {number}
   * @memberof CreditNoteLine
   */
  amountCad: number;
  /**
   *
   * @type {string}
   * @memberof CreditNoteLine
   */
  receivedAt?: string;
}

/**
 * Check if a given object implements the CreditNoteLine interface.
 */
export function instanceOfCreditNoteLine(
  value: object,
): value is CreditNoteLine {
  if (!("amountCad" in value) || value["amountCad"] === undefined) return false;
  return true;
}

export function CreditNoteLineFromJSON(json: any): CreditNoteLine {
  return CreditNoteLineFromJSONTyped(json, false);
}

export function CreditNoteLineFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreditNoteLine {
  if (json == null) {
    return json;
  }
  return {
    amountCad: json["amountCad"],
    receivedAt: json["receivedAt"] == null ? undefined : json["receivedAt"],
  };
}

export function CreditNoteLineToJSON(json: any): CreditNoteLine {
  return CreditNoteLineToJSONTyped(json, false);
}

export function CreditNoteLineToJSONTyped(
  value?: CreditNoteLine | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    amountCad: value["amountCad"],
    receivedAt: value["receivedAt"],
  };
}
